import { useQuery } from "@tanstack/react-query";
import subscriptionService, { PlanLimitUsage } from "services/admin/subscription.service";

// Использование лимитов тарифа: пользователи, каналы, ИИ-ответы за месяц
export const useGetPlanUsage = (orgID: string) => {
    return useQuery({
        queryKey: ['plan-usage', orgID],
        queryFn: async () => {
            const { data } = await subscriptionService.getUsage();
            return (data || []) as PlanLimitUsage[];
        },
        enabled: !!orgID,
    });
};
